import { StyledCreatePlaylistModal } from "./styledComponents";
import { CreatePlaylistModalContent, CreatePlaylistModalProps } from "./CreatePlaylistModalContent";

/**
 * Create Playlist Modal component
 */
export const CreatePlaylistModal = (props: CreatePlaylistModalProps) => {
    return (
        <StyledCreatePlaylistModal open={props.open} classes={{ paper: "kms-ds-create-playlist-modal" }}>
            <CreatePlaylistModalContent {...props} />
        </StyledCreatePlaylistModal>
    );
};
